import * as DOMPurify from 'dompurify';

/**
 * We have to fudge the way we use Dompurify as Dompurify is a CommonJS module without named exports.
 * We could make things easier by enabling `esModuleInterop` and `allowSyntheticDefaultImports` in our tsconfig
 * but this causes a whole load more work with the need to change hundreds of files
 */

// biome-ignore lint/suspicious/noExplicitAny: dompurify has odd exports - gotta import and retype the default
const { sanitize, addHook, removeAllHooks } = (DOMPurify as any).default as typeof DOMPurify;
export { addHook, removeAllHooks, sanitize };
